var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum } from 'class-validator';
import { CallPatientStatus } from '../../calls/index.js';
/**
 * Body for the authenticated in-app accept/decline of an appointment
 * participation (notification banner buttons). The patient is derived from the
 * auth context server-side (self only), so only the target status is sent.
 */
export class UpdateAppointmentParticipantStatusDto {
    status;
}
__decorate([
    IsEnum(CallPatientStatus),
    __metadata("design:type", String)
], UpdateAppointmentParticipantStatusDto.prototype, "status", void 0);
//# sourceMappingURL=update-appointment-participant-status.dto.js.map